// extracted by mini-css-extract-plugin
export default {"main":"PageNavItem_main__drD52","active":"PageNavItem_active__sS721","icon":"PageNavItem_icon__fEQTV","name":"PageNavItem_name__wLa8I"};